import React, {useEffect} from 'react'
import SkillsIcons from '../SkillsIcons'
import './styles.css'
import { tecnologies } from './../../settings'
import aos from "aos";
import 'aos/dist/aos.css'

export default function SkillsScreen () {
    useEffect(() => {
        aos.init({duration: 1000})
    })

    // let tecnologies = {
    //     front: ["html", "css", "bootstrap", "react", "redux", "javascript"],
    //     back: ["nodejs", "express", "sequelize", "mongo"],
    //     db: ["postgresql", "sqlite", "mongo"],
    // }

    return (
        <div className="skills-screen component">
                <h2 data-aos="fade" className='skills-title'>Skill Stack</h2>

            <div className='div-container'>

            
                {
                    Object.keys(tecnologies).map(el => {
                        return(

                            <SkillsIcons key={el} stack={el} names={tecnologies[el]}/>
                        )
                    }
                    
                    )
                }
            </div>
            
            {/* <div className='aditional-skills'>
                <h3><i className="fa-solid fa-cloud"></i></h3>
                <div className="contain">

                </div>

            </div> */}

            
        </div>
    )
}